import { Box } from '@chakra-ui/react';
import type { BoxProps } from '@chakra-ui/react';

type ContentWrapperProps = BoxProps & {
	children: React.ReactNode;
};

const ContentWrapper = ({ children, ...rest }:ContentWrapperProps) => {
	return (
		<Box
			pb={24}
			pt={16}
			px={12}
			{...rest}
		>
			{children}
		</Box>
	);
};

export default ContentWrapper;